import { Pipe, PipeTransform } from '@angular/core';
import { IVideo } from '@collections/common/interfaces/video.interface';
import { Cloudinary } from '@cloudinary/url-gen/instance/Cloudinary';
import {crop, scale} from "@cloudinary/url-gen/actions/resize";

export const baseVideoUrl = 'https://res.cloudinary.com/expometals/video/upload';

@Pipe({
    name: 'getStandVideoUrl',
    standalone: true
})
export class GetStandVideoUrlPipe implements PipeTransform {
  transform(video: IVideo , size: 'header' | 'full', format: 'mp4' | 'webm' | 'jpg', bp: 'xs' | 'md', quality: string | number='auto'): string {
    const public_id = video ? video.public_id : 'assets/exp-world'
    const cld = new Cloudinary({
      cloud: {
        cloudName: 'expometals'
      }
    });
    const _format = format === 'jpg' ?  'webp' : format;
    const v = cld.video(public_id).format(_format).quality(quality);
 
    if (bp === 'xs') {
      if (size === 'header') {
        v.resize(crop(800, 680));
      } else {
        v.resize(scale(400));
      }

    } else {
      if (size === 'header') {
        v.resize(scale(700, 300));
      }
      
    }
    return v.toURL()
    // const cldVideo = cld.video(video.public_id);
    // cldVideo.resize(scale().width(width).aspectRatio(AspectRatio.ar16X9()));
    // return cldVideo.toURL();

    // const aspectRatio = size === 'header' ? video?.aspect_ratio > 1.4 ? '/t_16-9/' : '/t_4-3-to-16-9/' : '/q_auto:good/';
    // const url = baseVideoUrl + aspectRatio + public_id + '.' + format;
    // return url ;
  }
}
